export default "__VITE_ASSET__tbZ15Vv8__"